// src/AttachmentPage.js
//
// UPDATED to full CRUD. Uses the new _label fields for readable parent
// descriptions instead of raw IDs.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import AttachmentForm from './AttachmentForm';

function AttachmentPage({ token }) {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingAttachment, setEditingAttachment] = useState(null);

  const refreshAttachments = () => {
    fetch(`${API_BASE_URL}/api/attachments/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setAttachments(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshAttachments();
  }, [token]);

  const describeParent = (a) => {
    if (a.project) return `Project: ${a.project_label}`;
    if (a.activity) return `Activity: ${a.activity_label}`;
    if (a.impact_record) return `Impact Record for ${a.impact_record_label}`;
    return 'Unlinked';
  };

  const handleNewClick = () => { setEditingAttachment(null); setShowForm(true); };
  const handleEditClick = (a) => { setEditingAttachment(a); setShowForm(true); };
  const handleSaved = () => { setShowForm(false); setEditingAttachment(null); refreshAttachments(); };
  const handleCancel = () => { setShowForm(false); setEditingAttachment(null); };

  const handleDelete = async (a) => {
    const confirmed = window.confirm(`Delete attachment "${a.title}"? This cannot be undone.`);
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/attachments/${a.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshAttachments();
  };

  if (loading) return <p className="text-gray-500">Loading attachments...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Attachments</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Attachment
        </button>
      </div>

      {showForm && (
        <AttachmentForm token={token} attachment={editingAttachment} onSaved={handleSaved} onCancel={handleCancel} />
      )}

      <div className="grid gap-3">
        {attachments.map((a) => (
          <div key={a.id} className="bg-white rounded shadow p-4 flex justify-between items-center">
            <div>
              <p className="font-semibold">{a.title}</p>
              <p className="text-sm text-gray-500">
                Linked to: {describeParent(a)} - Uploaded {new Date(a.uploaded_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex gap-3 items-center">
              <a href={a.file} target="_blank" rel="noopener noreferrer"
                className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700">
                Download
              </a>
              <button onClick={() => handleEditClick(a)} className="text-blue-600 text-sm hover:underline">Edit</button>
              <button onClick={() => handleDelete(a)} className="text-red-600 text-sm hover:underline">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AttachmentPage;
